import React, { useState } from 'react';
import '../Styles/global.css';
import Layout from "../Components/Layout";

const ChefManager = () => {
    const [recipeName, setRecipeName] = useState('');
    const [preparationMethod, setPreparationMethod] = useState('');
    const [ingredients, setIngredients] = useState('');
    const [dishes, setDishes] = useState([]);
    const [activeStars, setActiveStars] = useState([false, false, false]);
    const [notification, setNotification] = useState('');

    const handleAddDish = () => {
        if (recipeName.trim() && preparationMethod.trim() && ingredients.trim()) {
            setDishes([...dishes, { recipeName, preparationMethod, ingredients }]);
            setRecipeName('');
            setPreparationMethod('');
            setIngredients('');
            setActiveStars([false, false, false]);
            setNotification('Gerecht toegevoegd!');
            setTimeout(() => {
                setNotification('');
            }, 3000); // Hide notification after 3 seconds
        }
    };

    const handleStarClick = (index) => {
        const newActiveStars = [...activeStars];
        newActiveStars[index] = !newActiveStars[index];
        setActiveStars(newActiveStars);
    };

    return (
        <Layout>
            <div className="dashboard">
                <h1>Chef Kok Dashboard</h1>
                <div className="form-group">
                    <input
                        type="text"
                        value={recipeName}
                        onChange={(e) => setRecipeName(e.target.value)}
                        className="input-field"
                        placeholder="Recept Naam"
                    />
                    <input
                        type="text"
                        value={preparationMethod}
                        onChange={(e) => setPreparationMethod(e.target.value)}
                        className="input-field"
                        placeholder="Bereidingswijze"
                    />
                    <textarea
                        value={ingredients}
                        onChange={(e) => setIngredients(e.target.value)}
                        className="input-field"
                        placeholder="Ingrediënten"
                    ></textarea>
                    <button onClick={handleAddDish} className="add-button">
                        Toevoegen
                    </button>
                </div>
                <ul className="dish-list">
                    {dishes.map((dish, index) => (
                        <li key={index} className="dish-item">
                            <h3>{dish.recipeName}</h3>
                            <p><strong>Bereidingswijze:</strong> {dish.preparationMethod}</p>
                            <p><strong>Ingrediënten:</strong> {dish.ingredients}</p>
                        </li>
                    ))}
                </ul>
                <div className="stars">
                    {activeStars.map((isActive, index) => (
                        <div
                            key={index}
                            className={`star ${isActive ? 'active' : ''}`}
                            onClick={() => handleStarClick(index)}
                        ></div>
                    ))}
                </div>
                {notification && <div className="notification">{notification}</div>}
            </div>
        </Layout>
    );
};

export default ChefManager;